import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from '@mui/material';

interface SuccessRateTrendChartProps {
  data: Array<{ week: string; successRate: number; failureCount: number }>;
}

export const SuccessRateTrendChart: React.FC<SuccessRateTrendChartProps> = ({ data }) => {
  const theme = useTheme();

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="colorSuccessRate" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={theme.palette.success.main} stopOpacity={0.8} />
            <stop offset="95%" stopColor={theme.palette.success.main} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="week" tick={{ fontSize: 12 }} />
        <YAxis domain={[0, 100]} tick={{ fontSize: 12 }} unit="%" />
        <Tooltip
          formatter={(value: number) => [`${value}%`, 'Erfolgsquote']}
          contentStyle={{
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          }}
        />
        <Area
          type="monotone"
          dataKey="successRate"
          stroke={theme.palette.success.main}
          fillOpacity={1}
          fill="url(#colorSuccessRate)"
          strokeWidth={2}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
